import { Box, Button, Dialog, Grid, IconButton, LinearProgress, Typography, TextField, InputAdornment } from '@mui/material';
import { TEXT_TITLE_COLOR } from '../../constants/colors';
import useCategoryController from './controller';
import Delete_IC from '../../assets/images/logo/delete_ic.svg'
import { IMAGE_CATEGORY_ROOT_URL } from '../../constants/imageUrl';
import FormCategoryView from './components';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import SearchNotFound from '../../components/searchNotFound';
import { SuppliesMainGroupName } from '../../models/suppliesMain';
import { MainCategoryForm } from './form';
import SearchIcon from '@mui/icons-material/Search';
import ConfirmDialog from '../../components/ConfirmDialog';
import { useTranslation } from 'react-i18next';
import LoadingAnimatedIcon from '../../components/loading/loadingAnimated';
import ButtonExportCsv from '../../components/ButtonExportCsv';
import { MASTER_MAIN_GROUP_CSV_HEADER } from './csvHeader/mainCsvHeader';
import { MASTER_DIVISION_CSV_HEADER } from './csvHeader/divisionCsvHeader';
import { MASTER_CATEGORY_CSV_HEADER } from './csvHeader/categoriesCsvHead';
import { MASTER_SUB_CATEGORIES_CSV_HEADER } from './csvHeader/subCatCsvHeader';
import ButtonUploadCsv from '../../components/ButtonUploadCsv';

const CategoryView = () => {
  const controllers = useCategoryController();
  const { t } = useTranslation('global');

  return (
    <>
      {
        !controllers.loading ?
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <LoadingAnimatedIcon />
          </Box>
          : <Box>
            {
              controllers.openForm ?
                <Box>
                  <FormCategoryView
                    data={controllers.selectedMainCategory}
                    selectedMainId={controllers.selectedMainCategory}
                    onClose={controllers.handleCloseForm}
                  />
                </Box>
                :
                <Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2 }}>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, width: '100%' }}>
                      <Typography variant="h4" fontWeight='bold' color={TEXT_TITLE_COLOR}>{t("masterCategory_page.Category manage")}</Typography>
                      <TextField
                        fullWidth
                        placeholder={`${t("masterCategory_page.Search Category name")}`}
                        value={controllers.searchValue}
                        onChange={controllers.handleSearch}
                        sx={{ maxWidth: 250, ml: 2 }}
                        size="small"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchIcon />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Box>
                  </Box>

                  <Box mt={3} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2 }}>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 2, width: '100%', justifyContent: 'space-between' }}>
                      <Typography variant='h5' fontWeight='bold' color={TEXT_TITLE_COLOR}>
                        {t("masterCategory_page.All Main category")} ({controllers.filterData.length})
                      </Typography>
                      <Box sx={{ display: 'flex', gap: 1 }}>
                        {/* <ButtonUploadCsv onChange={controller.handleSendMultipleSms} title="Update Category by CSV" loading={controller.sendingMultipleSms} /> */}
                        {/* <LoadingButton loading={controllers.loadingUpdateAllCategories} variant='contained' color='secondary' onClick={controllers.handleUpdateAllBranchCategories} sx={{ textTransform: 'none', color: '#fff' }}>
                          Upload Categories
                        </LoadingButton> */}
                        <Button variant='contained' color='secondary' onClick={controllers.handleOpenAddCategory} sx={{ textTransform: 'none', color: '#fff' }}>
                          <AddIcon />
                          &nbsp;
                          {t("masterCategory_page.Create new category")}
                        </Button>
                      </Box>
                    </Box>
                  </Box>
                  <Typography variant='h6' mt={1} color={TEXT_TITLE_COLOR} fontWeight="bold">{t("masterCategory_page.Export Csv file")}</Typography>
                  <Box mt={2} mb={1} sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <ButtonExportCsv loading={false} onClick={controllers.handleExportMasterMainCsv} buttonRef={controllers.buttonExportMainRef} title={t("masterCategory_page.Export Main Group Csv")}data={controllers.dataExportMainGroupCsv} filename="Master MainGroup.csv" headers={MASTER_MAIN_GROUP_CSV_HEADER} />
                    <ButtonExportCsv loading={false} onClick={controllers.handleExportMasterDivisionCsv} buttonRef={controllers.buttonExportDivisionRef} title={t("masterCategory_page.Export Division Csv")} data={controllers.dataExportDivisionCsv} filename="Master Division.csv" headers={MASTER_DIVISION_CSV_HEADER} />
                    <ButtonExportCsv loading={false} onClick={controllers.handleExportMasterCategoriesCsv} buttonRef={controllers.buttonExportCategoriesRef} title={t("masterCategory_page.Export Categories Csv")}  data={controllers.dataExportCategoriesCsv} filename="Master Categories.csv" headers={MASTER_CATEGORY_CSV_HEADER} />
                    <ButtonExportCsv loading={false} onClick={controllers.handleExportMasterSubCategoriesCsv} buttonRef={controllers.buttonExportSubCategoriesRef} title={t("masterCategory_page.Export Sub Categories Csv")}data={controllers.dataExportSubCategories} filename="Master Sub Categories.csv" headers={MASTER_SUB_CATEGORIES_CSV_HEADER} />
                  </Box>
                  <Box mt={2} mb={1} sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <ButtonUploadCsv title={t("masterCategory_page.Upload main Group")} loading={controllers.loadingImportMasterMain} onChange={controllers.handleUploadMainGroup}/>
                    <ButtonUploadCsv title={t("masterCategory_page.Upload Division")}loading={controllers.loadingImportMasterDivision} onChange={controllers.handleUploadDivision}/>
                    <ButtonUploadCsv title={t("masterCategory_page.Upload Categories")} loading={controllers.loadingImportMasterCategories} onChange={controllers.handleUploadCategories}/>
                    <ButtonUploadCsv title={t("masterCategory_page.Upload Sub Category")} loading={controllers.loadingImportMasterSubCategories} onChange={controllers.handleUploadSubCategories}/>
                  </Box>
                  {/* <Typography variant='h6' mt={1} color={TEXT_TITLE_COLOR} fontWeight="bold">Upload Csv file</Typography> */}
                  {/* <Box mt={2} mb={2} sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <ButtonUploadCsv loading={controllers.loadingImportMasterMain} onChange={controllers.handleUploadMainGroup} title='Upload Main Group' />
                    <ButtonUploadCsv loading={controllers.loadingImportMasterDivision} onChange={controllers.handleUploadDivision} title='Upload Division' />
                    <ButtonUploadCsv loading={controllers.loadingImportMasterCategories} onChange={controllers.handleUploadCategories} title='Upload Categories' />
                    <ButtonUploadCsv loading={controllers.loadingImportMasterSubCategories} onChange={controllers.handleUploadSubCategories} title='Upload Sub Categories' />
                  </Box> */}
                  <Grid container spacing={2} mt={1} sx={{ display: 'flex', flexWrap: 'wrap' }}>
                    {
                      controllers.filterData.map((cat: SuppliesMainGroupName) => (
                        <Grid item xs={12} sm={6} md={3} key={cat.id} >
                          <Box sx={{
                            minHeight: 200, p: 2, borderRadius: '16px', width: 'auto', height: 'auto', boxShadow:
                              '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
                            background: '#f5fcff'
                          }}>
                            <Box>
                              <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                <img src={IMAGE_CATEGORY_ROOT_URL + cat?.icon?.url} style={{ width: '40px', height: '40px' }} alt="" />
                                <Box>
                                  <IconButton onClick={() => controllers.handleOpenForm(cat.id)}>
                                    <RemoveRedEyeIcon />
                                  </IconButton>
                                  <IconButton onClick={() => controllers.handleOpenEdit(cat.id)}>
                                    <EditIcon />
                                  </IconButton>
                                  {/* <IconButton onClick={() => controllers.handleOpenDelete(cat.id)}>
                                    <img src={Delete_IC} style={{ width: '20px', height: '20px' }} alt="" />
                                  </IconButton> */}
                                </Box>
                              </Box>
                              <Box mt={2}>
                                <Typography fontWeight='bold'>MG.code : {cat.code}</Typography>
                                <Typography fontWeight='bold'>MG eng name : <span style={{ color: 'grey' }}>{cat.main_group_name_en}</span></Typography>
                                <Typography fontWeight='bold'>MG lao name: <span style={{ color: 'grey' }}>{cat.main_group_name_la}</span></Typography>
                              </Box>
                            </Box>
                          </Box>
                        </Grid>
                      ))
                    }
                  </Grid>
                  {
                    controllers.isSearchNotFound && (
                      <SearchNotFound searchValue={controllers.searchValue} />
                    )
                  }
                  <ConfirmDialog
                    open={controllers.openDeleteForm}
                    title={t('Do you want to delete this data ?')}
                    loading={controllers.loadingButtonDelete}
                    onCancel={controllers.handleCloseDeleteForm}
                    onConfirm={controllers.handleDelete}
                  />
                  <Box>
                    <Dialog
                      fullWidth
                      maxWidth={'lg'}
                      open={controllers.openMainCategory}
                    >
                      <MainCategoryForm
                        onClose={controllers.handleCloseAddCategory}
                        onfetchData={controllers.handleFetchDataMainCategory}
                        selectedMain={controllers.selectedMainCategoryId}
                        onSetSelectedMain={controllers.onSetSelectedMain}
                      />
                    </Dialog>
                  </Box>
                </Box>
            }
          </Box>
      }
    </>
  );
};
export default CategoryView;